var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1534 26.3784H32.6534C33.3537 26.3783 34.0277 26.6454 34.5377 27.1252C35.0478 27.6051 35.3557 28.2614 35.3984 28.9604L35.4034 29.1284V32.4824C35.9485 32.6371 36.4326 32.9563 36.7894 33.3964C37.1463 33.8365 37.3587 34.3761 37.3974 34.9414L37.4034 35.1284V42.6284C37.4034 42.8184 37.3312 43.0013 37.2015 43.1401C37.0717 43.279 36.8941 43.3634 36.7046 43.3764C36.515 43.3893 36.3276 43.3298 36.1801 43.2099C36.0327 43.09 35.9363 42.9186 35.9104 42.7304L35.9034 42.6284V40.3784H18.9034V42.6284C18.9034 42.8096 18.8378 42.9847 18.7187 43.1213C18.5996 43.2579 18.435 43.3467 18.2554 43.3714L18.1534 43.3784C17.9722 43.3783 17.7971 43.3127 17.6605 43.1936C17.5239 43.0745 17.4351 42.9099 17.4104 42.7304L17.4034 42.6284V35.1284C17.4034 33.8694 18.2494 32.8084 19.4034 32.4814V29.1284C19.4034 28.4281 19.6705 27.7542 20.1503 27.2441C20.6301 26.734 21.2865 26.4261 21.9854 26.3834L22.1534 26.3784ZM34.6534 33.8784H20.1534C19.844 33.8782 19.5455 33.9929 19.3157 34.2001C19.0859 34.4074 18.9411 34.6925 18.9094 35.0004L18.9034 35.1284V38.8784H35.9034V35.1284C35.9033 34.8191 35.7886 34.5208 35.5813 34.2912C35.3741 34.0616 35.0891 33.917 34.7814 33.8854L34.6534 33.8784ZM32.6534 27.8784H22.1534C21.844 27.8782 21.5455 27.9929 21.3157 28.2001C21.0859 28.4074 20.9411 28.6925 20.9094 29.0004L20.9034 29.1284V32.3784H22.4034C22.4034 32.1131 22.5088 31.8588 22.6963 31.6713C22.8839 31.4837 23.1382 31.3784 23.4034 31.3784H25.4034C25.6484 31.3784 25.8848 31.4683 26.0678 31.6311C26.2508 31.7938 26.3678 32.0181 26.3964 32.2614L26.4034 32.3784H28.4034C28.4034 32.1131 28.5088 31.8588 28.6963 31.6713C28.8839 31.4837 29.1382 31.3784 29.4034 31.3784H31.4034C31.6484 31.3784 31.8848 31.4683 32.0678 31.6311C32.2508 31.7938 32.3678 32.0181 32.3964 32.2614L32.4034 32.3784H33.9034V29.1284C33.9036 28.8189 33.7889 28.5204 33.5817 28.2906C33.3744 28.0608 33.0893 27.916 32.7814 27.8844L32.6534 27.8784Z",
    fill: "url(#paint0_radial_189:163)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.17615,
    y: 0.990662,
    width: 52.4547,
    height: 62.7759,
    rx: 4.75,
    stroke: "url(#paint1_radial_189:163)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_189:163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4034 42.6284) rotate(-60.149) scale(23.636 25.8952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_189:163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1648 61.2249) rotate(-67.7929) scale(82.4166 73.1884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.0ef0018a.svg";
export { ForwardRef as ReactComponent };